<template>
  <div>
    <div class="map-menu">
      <div
        class="grid-map-menu-icon"
        :class="{ selected: openMenu }"
        @click="toggleMenu()"
      />
      <div class="menu-item-list">
        <div v-if="openMenu">
          <div
            v-for="(item, index) in displayMenu"
            :key="index"
            class="menu-item aisea-pt-2 aisea-pl-3"
            :class="{
              selected:
                activeSidebarForGrid.componentName === item.componentName,
            }"
            @click="openSidebar(item.componentName)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 右メニューの選択欄を表示するコンポーネント
 * @parent O.MapViewGridItem
 * @props mapId: String １マップに割り当てられているマップid
 */
import { createNamespacedHelpers, mapGetters } from "vuex";

const { mapMutations: mapMutationsOfGridMap, mapState: mapStateOfGridMap } =
  createNamespacedHelpers("gridMap");

const MENU = [
  { name: "自社船", componentName: "ownVessel" },
  { name: "選択船", componentName: "selectedVessel" },
  {
    name: "資機材運搬管理",
    componentName: "equipmentBaseStation",
    isAddon: true,
    addonKey: "GKMG_BASE_STATION",
  },
  { name: "プロット", componentName: "plot" },
  {
    name: "プライベートプロット",
    componentName: "privatePlot",
    isAddon: true,
    addonKey: "GKMG_PRIVATE_PLOT",
  },
  { name: "フィルター", componentName: "filterMap" },
  { name: "設定", componentName: "settings" },
];

export default {
  name: "O.MapMenu",
  props: {
    mapId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /** メニュー項目 */
      menu: MENU,
      /** メニュー項目の開閉フラグ */
      openMenu: false,
    };
  },
  computed: {
    ...mapStateOfGridMap({
      /** ドロップダウンメニューのインタラクション */
      activeSidebarForGrid: (state) => state.activeSidebarForGrid,
    }),
    ...mapGetters(["getAddonFlag"]),
    // 権限によって表示メニューを変更する。
    displayMenu() {
      return this.menu.filter((menu) => {
        return !menu.isAddon || this.getAddonFlag(menu.addonKey);
      });
    },
  },
  methods: {
    ...mapMutationsOfGridMap(["SET_ACTIVE_SIDEBAR_FOR_GRID"]),
    /** メニューの開閉を行う */
    toggleMenu() {
      this.openMenu = !this.openMenu;
    },
    /**
     * 選択したメニューを開く
     * 既に開いているメニューを閉じる
     */
    openSidebar(componentName) {
      this.SET_ACTIVE_SIDEBAR_FOR_GRID({
        mapId: this.mapId,
        isActive: true,
        componentName: componentName,
      });
    },
  },
  watch: {
    activeSidebarForGrid() {
      if (this.activeSidebarForGrid.isActive) {
        this.openMenu = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.map-menu {
  position: absolute;
  text-align: right;
  top: 10px;
  right: 12px;
  z-index: 5;

  .grid-map-menu-icon {
    height: 34px;
    width: 34px;
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #d5d5d5;
    border-radius: 17.7px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    border: none;
    outline: none;
    background-image: url("../../assets/images/icons/lolcal/grid_map_menu_default.svg");
    background-repeat: no-repeat;
    background-position: center;

    &:hover {
      cursor: pointer;
      background-color: #989898;
    }

    &:active {
      background-color: #696969;
    }
  }

  .grid-map-menu-icon.selected {
    background-image: url("../../assets/images/icons/lolcal/grid_map_menu_select.svg");
  }

  .menu-item-list {
    position: absolute;
    top: 40px;
    right: 0px;

    .menu-item {
      /* Auto layout */
      font-family: $aisea-font-family;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 10px;

      width: 160px;
      height: 32px;

      background: $aisea-dark-blue;
      color: $aisea-pure-white;

      &:hover {
        cursor: pointer;
        background: #595d69;
      }

      &:active {
        background: #8b8e97;
      }
    }

    .menu-item.selected {
      background: #1e6790;
    }
  }
}
</style>
